import React from "react";
import { motion } from "framer-motion";

export default function IlMorsoSection() {
  const points = [
    { t: "FOCACCIA CROCCANTE", d: "Impasto artigianale, cotta ogni giorno. Croccante fuori." },
    { t: "PULLED PORK FATTO DA NOI", d: "Cotto a bassa temperatura per ore. Succoso dentro." },
    { t: "TOPPING & SALSE", d: "Combinazioni decise. Niente compromessi. Solo voglia." },
  ];
  return (
    <section id="morso" className="relative bg-[#0C0C0C] grain py-14 sm:py-20 border-t border-[#161616]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center">
          <span className="font-display font-bold uppercase tracking-[0.3em] text-sm text-[#FFC20E]">IL MORSO</span>
          <h2 className="font-display font-black uppercase display-tight text-5xl sm:text-7xl mt-2">
            <span className="text-white">CROCCANTE FUORI. </span>
            <span className="text-[#FFC20E]">SUCCOSO DENTRO.</span>
          </h2>
        </div>
        <div className="mt-10 grid md:grid-cols-3 gap-5">
          {points.map((p, i) => (
            <motion.div
              key={p.t}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              className="bg-[#141414] border border-[#242424] rounded-2xl p-6"
            >
              <span className="font-display font-black text-5xl text-[#FFC20E]">0{i + 1}</span>
              <h3 className="font-display font-black uppercase text-2xl text-white mt-2 leading-none">{p.t}</h3>
              <p className="text-white/60 mt-2">{p.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
